export namespace Enums {
    export enum Messages {
        AcessoCidadaoExpiredWarning = `Sessão expirada no Acesso Cidadão. Aguarde a renovação da sessão na janela aberta automaticamente e, após seu fechamento,
            tente realizar aqui novamente a última ação solicitada`,
        GeneralError = 'Erro ao executar a operação (FE01)',
        GeneralErrorInterceptor = 'Erro ao executar a operação (FE07)',
        CsvExportError = 'Erro ao gerar os arquivos CSV',
        CsvImportError = 'Erro ao importar dados do arquivo CSV',
        CsvEmptyError = 'Arquivo CSV vazio',
        CsvNoRecordsError = 'Nenhum registro no formato esperado foi encontrado no arquivo CSV fornecido',
        CsvImportSuccess = 'Dados do arquivo CSV importados com sucesso',
        CsvGenerationSuccess = 'Arquivo CSV gerado com sucesso',
        NoFormSchemaError = 'Não foi possível carregar as definições do Construtor de Formulário',
        CannotCaptureAsCitizenError = `Tarefas de preenchimento de formulário não podem conter, na definição do formulário, anexos configurados para captura
            como "Cidadão" caso o público-alvo do Fluxo não seja "Cidadão"`,
        CannotCaptureAsPublicAgentError = `Tarefas de preenchimento de formulário não podem conter, na definição do formulário, anexos configurados para captura
            como "Servidor" caso o público-alvo do Fluxo seja "Cidadão"`,
        NoFormBuilderButtonError = 'Tarefas de preenchimento de formulário devem conter, na definição do formulário, um Botão para que o usuário possa submetê-lo',
        NoDocumentClassIdError = `Tarefas que sejam executadas por servidores e que geram documento próprio capturado no E-Docs devem conter uma definição
            para a Classificação Documental`,
        NoRecipientError = 'Tarefas de encaminhamento de conteúdo devem conter uma definição para o Destinatário do encaminhamento que será realizado no E-Docs',
        NoProcessLocation = 'Tarefas de autuação de Processo devem conter uma definição para o Local de Autuação do mesmo em sua configuração do E-Docs',
        NoProcessClass = 'Tarefas de autuação de Processo devem conter uma definição para a Classificação Processual em sua configuração do E-Docs',
        NoProcessSummary = 'Tarefas de autuação de Processo devem conter uma definição para o Resumo do Processo em sua configuração do E-Docs',
        NoProcessStakeholders = 'Tarefas de autuação de Processo devem conter ao menos um Interessado do Processo em sua configuração do E-Docs',
        NoDispatchRecipient = 'Tarefas de despacho de Processo devem conter um Destinatário do Despacho em sua configuração do E-Docs',
        NoDispatchMessage = 'Tarefas de despacho de Processo devem conter uma Mensagem de Despacho em sua configuração do E-Docs',
        NoDispatchAccessLevel = 'Tarefas de despacho de Processo devem conter o Nível de Acesso do Termo de Despacho em sua configuração do E-Docs',
        NoAddToProcessMessage = 'Tarefas de entranhamento em Processo devem conter uma Mensagem de Entranhamento em sua configuração do E-Docs',
        NoAddToProcessAccessLevel = 'Tarefas de entranhamento em Processo devem conter o Nível de Acesso do Termo de Entranhamento em sua configuração do E-Docs',
        NoDocumentClassIdOnAddToProcessError = 'Tarefas de entranhamento em Processo com formas de obtenção do processo que não a da própria instância exigem a configuração da Classificação Documental para eventuais ações de cancelamento',
        NoProcessProtocolFormFieldError = 'Tarefas de entranhamento em Processo com forma de obtenção do processo por campo do formulário exige a configuração do respectivo campo de onde se deve obter o protocolo do processo',
        NoResolverIdError = 'Tarefas de API de saída devem conter uma definição para seus Atores Resolvedores',
        NoEndpointUrlError = 'Tarefas de API de saída devem conter uma definição para a URL do endpoint de destino',
        NoConfigSchemaError = 'Configuração de Tarefa não encontrada',
        NoFlowInboxError = 'O usuário não possui acesso de Administrador em nenhuma Caixa de Fluxo',
        NoGatewayPathsSequenceNameError = 'Tarefas de Divisão de Fluxo devem conter, em suas configurações, nomes para suas sequências de Tarefas',
        NoGatewayPathsConditionsError = `Tarefas de Divisão de Fluxo devem conter, em suas configurações, ao menos uma condição para divisão entre suas
            sequências de Tarefas`,
        NoGatewayPathsFormFieldError = 'Toda regra de condição de uma Tarefa de Divisão de Fluxo deve conter um código de campo do formulário utilizado para comparação',
        EmptyGatewayPathError = 'As Sequências da Divisão de Fluxo devem conter ao menos uma Tarefa cada',
        SingleGatewayPathsTaskOnly = 'Todo Fluxo deve possuir no máximo uma Tarefa de Divisão de Fluxo',
        OwnerImmediateSupervisorOnFirstForwardError = `A primeira Tarefa de encaminhamento de conteúdo de um Fluxo não pode ser configurada com a opção de destinatário
            "Gestor imediato do solicitante do Fluxo" — utilize a opção "Gestor imediato do executor da Tarefa" para obter o comportamento desejado`,
        TargetCitizenImmediateSupervisorError = `Fluxos com público-alvo "Cidadão" não podem apresentar Tarefas de encaminhamento de conteúdo ou despacho de processo com
            o Destinatário sendo uma das opções de "Gestor imediato"`,
        TargetCitizenOwnRoleError = `Fluxos com público-alvo "Cidadão" não podem apresentar Tarefas de encaminhamento de conteúdo com
            o Destinatário sendo "Caixa do papel do solicitante do Fluxo"`,
        OwnRoleFlowSizeError = `Fluxos com Destinatário sendo "Caixa do papel do solicitante do Fluxo" devem obrigatoriamente assumir sua forma mínima
            e só podem apresentar no máximo 3 Tarefas (Início, Encaminhamento e Encerramento)`,
        ConditionalRecipientsOnStartInboundApiError = `Fluxos que se iniciem por API não podem conter destinatários condicionais em Tarefas de
            encaminhamento ou despacho`,
        AccessDenied = 'Acesso Negado',
        NoAccessToResource = 'Você não possui acesso a esse recurso',
        MyNewFlow = 'Meu Novo Fluxo',
        Warning = 'Aviso',
        Error = 'Erro',
        Success = 'Sucesso',
        EnvironmentLocalhost = 'Localhost',
        EnvironmentDevelopment = 'Desenvolvimento',
        EnvironmentStaging = 'Homologação',
        EnvironmentLearning = 'Treinamento',
        MyFlowDefinitions = 'Meus Fluxos',
        CpfParameterTip = 'e.g. "{{cpf}}"',
        IdUsuarioSolicitanteParameterTip = 'e.g. "{{idUsuarioSolicitante}}"',
        IdUsuarioExecutorParameterTip = 'e.g. "{{idUsuarioExecutor}}"',
        FormParameterTip = 'e.g. "{{matricula}}"',
        FormTypeStartTag = '{$|form|$}_',
        FormTypeSeparatorTag = '{$|_|$}',
        FormTypeEndTag = '_{$|form|$}',
        SketchSaveSuccess = 'Alterações em modo rascunho salvas com sucesso',
        DataValidationError = 'Erro na validação de dados',
        FlowStarterTaskNotFound = 'Tarefa Disparadora de Fluxo não encontrada',
        FirstTaskShouldBeStart = 'A primeira tarefa do Fluxo deve ser de um dos tipos de "Início"',
        LastTaskShoudBeFinish = 'Todas as possíveis últimas tarefas do Fluxo devem ser do tipo "Fim"',
        FlowDefinitionIsReadOnly = 'O Fluxo não pode ser alterado em modo "Somente Leitura"',
        InvalidNextType = 'Encadeamento de Tarefas não permitido. Tarefas do tipo "{0}" só podem ser sucedidas por Tarefas dos seguintes tipos: {1}',
        PdfFilesOnly = 'Apenas arquivos com extensão PDF são permitidos',
        PdfMaxSizeLimit = 'O tamanho do arquivo PDF deve ser menor que {0}MB',
        FileMaxSizeLimit = 'O tamanho do arquivo deve ser menor que {0}MB',
        InvalidFileExtension = 'Apenas arquivos com as seguintes extensões são permitidos: "{0}"',
        JsonDeserializeError = 'Erro ao desserializar JSON: um ou mais pares de chave/valor possuem valores não suportados',
        JsonSerializeError = 'Erro ao serializar JSON: um ou mais pares de chave/valor possuem valores não suportados',
        KeyAlreadyAdded = 'Chave já adicionada anteriormente',
        EmptyKey = 'Chave não informada',
        EmptyPairValueType = 'Tipo de Valor do par de chave/valor não informado',
        NullOrEmpty = 'Valor informado nulo ou vazio',
        IsNotNumber = 'Regra selecionada não aplicável para valores de tipo texto',
        ConditionalFieldAdvanced = 'Este campo possui exibição condicional (avançado)',
        ConditionalFieldSimple = 'Este campo possui exibição condicional (simples)',
        InvalidKeyTemplate = 'A chave não está no formato do template "{{chave}}"',
        InvalidPairValue = 'Valor inválido para o Tipo de Valor escolhido',
        InvalidCancelByDeliberationOptions = "Valor inválido para as opções de cancelamento manual",
        InvalidAutoDeactivateOptions = 'Valor inválido para as opções de desativação automática',
        InvalidAutoActivateOptions = 'Valor inválido para as opções de ativação automática',
        InvalidAutoCancelOptions = 'Valor inválido para as opções de cancelamento automático',
        InvalidFlowObjectConfigSchemaSource = 'Valor inválido de código-fonte para as Configurações da Tarefa',
        InvalidFlowDefinitionConfigSchemaSource = 'Valor inválido de código-fonte para as Configurações do Fluxo',
        InvalidConfigSchemaSourceType = 'O tipo das Configurações de origem não coincide com o tipo das Configurações de destino',
        EmptyWhitelist = 'Adicione pelo menos um local à Lista de Permissão',
        NameMinLength = 'O campo "Nome" deve apresentar um tamanho mínimo de 3 caracteres (não vazios)',
        NoFlowInboxId = 'Adicione um critério para uma Caixa de Fluxos a fim de trazer novos resultados',
        NoOptionAvailable = '(nenhuma opção disponível)',
        SelectAnOption = '(selecione uma opção)',
        MandatoryConditionalFields = 'Entre com um valor para "Campo do Formulário" e "Valor do Campo"',
        MandatoryProcessSummary = 'Entre com um resumo para o Processo (ao menos 5 caracteres)',
        MandatoryDispatchSummary = 'Entre com uma mensagem para o Despacho (ao menos 5 caracteres)',
        MandatoryAddToProcessSummary = 'Entre com uma mensagem para o Entranhamento (ao menos 5 caracteres)',
        FormSchemaParsingError = 'Configuração de formulário inválida. As alterações não foram aplicadas',
        MandatoryWaitingMessage = 'É obrigatório o fornecimento de mensagem de espera ao requerente. Tamanho mínimo: 10 caracteres',
        MandatoryAttachment = 'É necessária a configuração de ao menos um Anexo',
        MandatoryAttachmentDocumentClass = 'Todos os Anexos devem conter uma Classificação Documental',
        DefaultEmptyValue = '(N/D)',
        NewVersionConfirmMessage = `Deseja <b>gerar uma nova versão</b> para o Fluxo <b>{0}</b>?
            <br><br>Uma vez versionado, o Fluxo poderá ser editado novamente e só poderá instanciado por usuários na nova versão quando for publicado.`,
        CloneConfirmMessage = `Deseja <b>clonar</b> o Fluxo <b>{0}</b>?
            <br><br>O Fluxo de origem não será alterado e suas eventuais instâncias não possuirão relação com o Fluxo duplicado. Apenas a última versão do
            Fluxo de origem será clonada.`,
        PublishConfirmMessage = `Deseja <b>publicar</b> o Fluxo <b>{0}</b>?
            <br><br>Uma vez publicado, o Fluxo estará disponível para instanciação por usuários e não poderá ser alterado até que uma nova versão seja criada.`,
        GroupByContextConfirmMessage = `Deseja <b>ativar o modo de Agrupamento de Fluxos por Contexto</b> para o Fluxo <b>{0}</b>?
            <br><br>Fluxos agrupados em um mesmo Contexto são exibidos em uma lista unificada para a escolha do usuário no momento da instanciação.`,
        ActivateConfirmMessage = `Deseja <b>ativar</b> o Fluxo <b>{0}</b>?
            <br><br>Uma vez ativado, o Fluxo estará disponível para novas instanciações por usuários, caso haja versões publicadas.`,
        DeactivateConfirmMessage = `Deseja <b>desativar</b> o Fluxo <b>{0}</b>?
            <br><br>Uma vez inativo, o Fluxo estará indisponível para novas instanciações por usuários, ainda que haja versões publicadas.`,
        DeleteConfirmMessage = `Deseja <b>remover</b> o Fluxo <b>{0}</b>?
            <br><br>Uma vez removido, o Fluxo não poderá ser acessado novamente.`,
        PinConfirmMessage = `Deseja <b>fixar</b> o Fluxo <b>{0}</b> no início da lista?`,
        UnpinConfirmMessage = `Deseja <b>desafixar</b> o Fluxo <b>{0}</b> do início da lista?`,
        ImmediateChangeOnPublicWarning = `Deseja <b>confirmar e salvar</b> as alterações no Fluxo?<br><br>
            Opções referentes ao <b>cancelamento e/ou desativação automáticos</b> foram alteradas, o que reflete <b>imediatamente</b>
            nos Fluxos publicados e/ou em andamento no portal Público (isto é, <b>sem que seja necessário</b> publicar este Fluxo novamente).`,
        AddItemToDirectoryMessage = `Deseja <b>ativar o modo de Adição de Fluxos para a Pasta {0}</b>?<br><br>
            Fluxos adicionados a uma pasta passam a ser exibidos dentro dela, facilitando a organização
            e a localização no momento da navegação pela lista de Fluxos.`,
        DeleteDirectoryConfirmMessage = `<b>Excluir pasta?</b><br><br>
            Esta pasta contém Fluxos. Ao excluí-la, a pasta será removida e todos os Fluxos dentro dela serão movidos automaticamente para a 
            <b>raiz da Caixa de Fluxos</b>. Deseja continuar?`,
        DeleteEmptyDirectoryConfirmMessage = `<b>Excluir pasta?</b><br><br>
            Tem certeza que deseja excluir a pasta <b>{0}</b>? Esta ação não pode ser desfeita.`,
        RemoveItemFromDirectoryMessage = `<b>Mover para a lista principal?</b><br><br>
            O Fluxo <b>{0}</b> será removido da pasta atual e voltará para a raiz da Caixa de Fluxos. Deseja continuar?`,
    }

    export enum Profiles {
        Administrator = 'Administrador',
        AdminAll = 'AdminAll',
        Owner = 'Owner',
        ErrorPage = 'ErrorPage'
    }

    export enum GatewayPathsLabels {
        True = 'Sim',
        False = 'Não'
    }

    export enum PagesPaths {
        FlowInboxDirectory = '/flow-inbox-directory',
        FlowDefinitionList = '/flow-definition-list',
        FlowDefinition = '/flow-definition',
        Dashboard = '/dashboard',
        UpdateHistory = '/update-history',
        Home = '/home',
        Error = '/error',
        AccessDenied = '/access-denied',
        LandingPage = '/',
        Documentation = 'https://docs.admin.e-flow.es.gov.br',
    }

    export enum TitleInfoType {
        UserName = 0,
        UserCpf = 1,
        FormField = 2
    }

    export enum FlowDefinitionItemActionType {
        Open = 0,
        Instantiate = 1,
        NewVersion = 2,
        Clone = 3,
        Publish = 4,
        Activate = 5,
        Deactivate = 6,
        Delete = 7,
        GroupByContext = 8,
        AddItemToContext = 9,
        RemoveItemFromContext = 10,
        MoveUpInContext = 11,
        MoveDownInContext = 12,
        Pin = 13,
        Unpin = 14,
        AddItemToDirectory = 15,
        RemoveFromDirectory = 16,
        AddItemToDirectoryMode = 17,
    }

    export enum DetailsAreaTabs {
        FlowDefinitionDetails = 0,
        FlowDefinitionDetailsHotConfigs = 1,
        FlowObjectDetails = 2,
        FormBuilder = 3,
        FormBuilderInboundApi = 4,
        HtmlEditor = 5,
        GatewayRules = 6,
        GatewayPaths = 7,
        MidwayOutboundApi = 8,
        OutboundApi = 9,
        ExtraContent = 10
    }

    export const DetailsAreaTabsLabel = new Map<DetailsAreaTabs, string>([
        [DetailsAreaTabs.FlowDefinitionDetails, 'Detalhes do Fluxo'],
        [DetailsAreaTabs.FlowDefinitionDetailsHotConfigs, 'Configurações Imediatas'],
        [DetailsAreaTabs.FlowObjectDetails, 'Detalhes'],
        [DetailsAreaTabs.FormBuilder, 'Construtor de Formulário'],
        [DetailsAreaTabs.FormBuilderInboundApi, 'Construtor de Formulário: Iniciar por API'],
        [DetailsAreaTabs.HtmlEditor, 'Editor de Modelo de Documento'],
        [DetailsAreaTabs.GatewayRules, 'Aplicação de Regra'],
        [DetailsAreaTabs.GatewayPaths, 'Divisão de Fluxo'],
        [DetailsAreaTabs.MidwayOutboundApi, 'API de Destino (Intermediária)'],
        [DetailsAreaTabs.OutboundApi, 'API de Destino (Final)'],
        [DetailsAreaTabs.ExtraContent, 'Conteúdo Extra']
    ]);

    export const DetailsAreaTabsLabelReversed = new Map<string, DetailsAreaTabs>([
        ['Detalhes do Fluxo', DetailsAreaTabs.FlowDefinitionDetails],
        ['Configurações Imediatas', DetailsAreaTabs.FlowDefinitionDetailsHotConfigs],
        ['Detalhes', DetailsAreaTabs.FlowObjectDetails],
        ['Construtor de Formulário', DetailsAreaTabs.FormBuilder],
        ['Construtor de Formulário: Iniciar por API', DetailsAreaTabs.FormBuilderInboundApi],
        ['Editor de Modelo de Documento', DetailsAreaTabs.HtmlEditor],
        ['Aplicação de Regra', DetailsAreaTabs.GatewayRules],
        ['Divisão de Fluxo', DetailsAreaTabs.GatewayPaths],
        ['API de Destino (Intermediária)', DetailsAreaTabs.MidwayOutboundApi],
        ['API de Destino (Final)', DetailsAreaTabs.OutboundApi],
        ['Conteúdo Extra', DetailsAreaTabs.ExtraContent]
    ]);

    export enum RecipientMode {
        ImmediateSupervisor = 1,
        Fixed = 2,
        Conditional = 3,
        PublicAgent = 4,
        OwnRole = 5,
        OwnerImmediateSupervisor = 6,
        OwnerHeadOfOrganization = 7
    }

    export enum DivisionMode {
        Deliberation = 1,
        Conditional = 2,
    }

    export enum AccessLevelFilterType {
        Citizen = 1,
        Patriarch = 2
    }

    export enum FlowInboxDirectoryMode {
        Creating = 'creating',
        Viewing = 'viewing'
    }

    export enum LocalStorageKeys {
        AdminFilter = 'admin-filter',
        AdminFlowInbox = 'admin-flow-inbox',
        UpdateHistoryLastSeenId = 'update-history-last-seen-id',
    }

    export enum ProcessOrigin {
        Instance = 1,
        PublicAgentDeliberation = 2,
        Form = 3
    }
}
